export default __webpack_public_path__ + "static/media/Nav-Queries.7f0237a4.svg";